import { render, staticRenderFns } from "./actDetailList.vue?vue&type=template&id=4636cff4&scoped=true"
import script from "./actDetailList.vue?vue&type=script&lang=js"
export * from "./actDetailList.vue?vue&type=script&lang=js"
import style0 from "./actDetailList.vue?vue&type=style&index=0&id=4636cff4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636cff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4636cff4')) {
      api.createRecord('4636cff4', component.options)
    } else {
      api.reload('4636cff4', component.options)
    }
    module.hot.accept("./actDetailList.vue?vue&type=template&id=4636cff4&scoped=true", function () {
      api.rerender('4636cff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_market_activities/components/actDetailList.vue"
export default component.exports